import {decimalOfInteger} from 'powtoon-commons/utils/numbers'
import {MINIMUM_STEP_SIZE, STEPS_PER_SECOND_VALUE} from 'powtoon-document/consts/duration'

export const MIN_WIDTH_FOR_SMALL_FLAGS = 32
export const MIN_WIDTH_FOR_A_TO_B_ICON = 55
export const MIN_WIDTH_FOR_EFFECT_ICON = 50
export const OFFSET_OF_EFFECT_ICON_IN_TIMELINE = 34
export const MIN_WIDTH_FOR_ASSET_ICON = 40
export const MIN_DRAGGING_STEP = decimalOfInteger
export const MIN_OUT_TRACKS_EFFECT_CHOOSER = 30
export const MIN_SELECTION_WIDTH_FOR_EFFECT_CHOOSER = 50
export const MIN_STEP_WIDTH = 17
export const MAX_TIMELINE_WIDTH = 1350
export const SCALE_BUTTONS_WIDTH = 25
export const SLIDE_CONTAINER_PADDING = 25
export const FULL_WIDTH_GLOBAL_TIMELINE_PADDING = 100
export const FULL_WIDTH_SLIDE_TIMELINE_PADDING = FULL_WIDTH_GLOBAL_TIMELINE_PADDING - SLIDE_CONTAINER_PADDING
export const ADD_SLIDE_BUTTONS_WIDTH = 45
export const GLOBAL_TIMELINE_MAX_ZOOM_EXTRA_PADDING = ADD_SLIDE_BUTTONS_WIDTH + 135
export const MIN_WIDTH_FOR_SOUND_SUMMARY_TEXT = 150
export const MIN_TRACK_DURATION = 0
export const EFFECT_DURATION = 0.5
export const MIN_ANIMATION_DURATION = 0.5
export const DEFAULT_ANIMATION_DURATION = 1.5
export const DEFAULT_B_POSITIONS_OFFSET = 40
export const TIMELINE_FPS_VALUE = STEPS_PER_SECOND_VALUE
export const TIMELINE_MINIMUM_STEP_SIZE = MINIMUM_STEP_SIZE
export const TIMELINE_MINIMUM_ZOOM = 0.009
export const TIMELINE_MIN_LINEAR_ZOOM = 0
export const TIMELINE_MAX_LINEAR_ZOOM = 1
export const AUDIO_SVG_WAVEFORM_PEAKS_PER_SECOND = 200
